export const makeGenericZodErrorMessage = (message: string) => ({
  errorMap: () => ({
    message,
  }),
})
